<template>
    <div>
        <div class=" flex items-center justify-between px-3">
            <span class=" font-[500]">Consolidation Information</span>
            <span class=" cursor-pointer flex items-center gap-2" @click="collapse = !collapse">Collapse <img
                    src="@/assets/images/arrow-up.svg" :class="[collapse && 'rotate-180']"
                    class=" transition-all duration-200" /></span>
        </div>
        <div v-if="!collapse">
            <div class="box_wrapper ">
                <hr class="w-full mb-2" />
                <div class="">
                    <span class=" flex w-full items-center text-gray-500 gap-2 font-[600] mb-3 mt-2">
                        VEHICLE INFO
                    </span>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Vehicle No:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.vehicleInfo?.vehicleNo }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Driver:</span> </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.vehicleInfo?.driver }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact No:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.vehicleInfo?.contactNo }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Vehicle Capacity:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.vehicleInfo?.vehicleCapacity }}</p>
                    </div>
                </div>
                <div class="">
                    <span class=" flex w-full items-center text-gray-500 gap-2 font-[600] mb-3 mt-2">
                        SHIPPING SERVICE
                    </span>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.name }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Businness Address:</span> </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.businessAddress }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Phone Number:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.phoneNumber }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Email Address:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.shippingService?.businessAddress }}</p>
                    </div>
                </div>
                <hr class="w-full mt-3 mb-01" />
                <div class="">
                    <span class=" flex w-full items-center text-gray-500 gap-2 font-[600] mb-3 mt-2">
                        FROM
                    </span>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.name }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Address:</span> </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.address }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Dispatched by:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.dispatch }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact No:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.user?.mobile_no }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact Email:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.origin?.user?.email }}</p>
                    </div>
                </div>
                  <div class="">
                    <span class=" flex w-full items-center text-gray-500 gap-2 font-[600] mb-3 mt-2">
                        TO
                    </span>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Name:</span>
                        </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.name }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Email:</span> </p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.email }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Manager:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.manager?.firstname }} {{ manifest?.destination?.manager?.lastname }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact No:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.user?.mobile_no }}</p>
                    </div>
                    <div class="detailsItem">
                        <p class="w-1/3 text-gray-500 flex flex-wrap"><span>Contact Email:</span></p>
                        <p class="w-2/3 font-semibold text-left">{{ manifest?.destination?.user?.email }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            collapse: false
        }
    },
    props: {
        manifest: {}
    },
    methods: {
        formatAmount(number) {
            return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        },
        statusColors(status) {
            const opac = "25";
            switch (status) {
                case "paid":
                    return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
                case "pending":
                    return { color: "#FFA600", backgroundColor: "#FCC21040" };
            }
        },
    },

}
</script>

<style lang="scss" scoped>
.box_wrapper {
    @apply flex flex-wrap mt-3 px-4;

    div {
        @apply w-full sm:w-6/12 py-0 px-0
    }
}

.trans_item {
    @apply w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-4;

    b {
        @apply font-[600]
    }
}

.order_status {
    @apply text-sm whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-6
}

.detailsItem {
    @apply flex flex-wrap mb-1 !w-full;
    p:nth-of-type(1){
        @apply text-gray-400
    }
      p:nth-of-type(2){
        @apply font-[400]
    }
}
</style>